import script from "./EmailSentTable.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailSentTable.vue?vue&type=script&setup=true&lang=js"

import "./EmailSentTable.vue?vue&type=style&index=0&id=580042e4&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\demo\\codebase 8x8\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-580042e4"]])

export default __exports__